import { Icon } from "@utp/react-components-prod";

interface ICardProps {
  icon: string;
  title: string;
  description: string;
}

const CardSummary = ({ icon, title, description }: ICardProps) => {
  return (
    <section
      aria-labelledby={`card-title`}
      aria-describedby={`card-description`}
      className="flex justify-between items-center border-solid border border-mid-grey-30 rounded-default p-4"
    >
      <div className="flex items-start">
        <Icon iconName={icon} size={20} className="mt-1" />
        <div className="ml-5">
          <p
            id={`card-title`}
            className="text-body-02 text-color-02  font-bold mb-2"
          >
            {title}
          </p>
          <span id={`card-description`} className="text-color-01 font-bold">
            {description}
          </span>
        </div>
      </div>
    </section>
  );
};

export default CardSummary;
